export default {
      id: "home-usage",
      viewBox: "0 0 18 18",
      url: "/assets/" + "icons.svg#home",
      toString: function () {
        return this.url;
      }
    }